import { css } from "emotion";

import { breakpoints, fonts } from "@cobliteam/base-components";

export const dividerWrapper = css`
  && {
    margin: 10px 0 20px;
  }
`;

export const datePickerWrapper = css`
  max-width: 150px;
  margin-right: 10px;
`;

export const select = css`
  flex: 1;
`;

export const rowWrapper = css`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  align-items: center;
`;

export const exportButtonStyle = css`
  && {
    margin-left: 20px;
    @media screen and (max-width: ${breakpoints.tablet}) {
      min-width: 120px;
    }
  }
`;

export const driversListStyle = (multipleDrivers: boolean) => css`
  margin-top: 15px;
  ${multipleDrivers || "display: none"};
`;

export const exportHover = css`
  width: 280px;
`;

export const exportHoverTitle = css`
  font-size: ${fonts.size.small};
  font-weight: ${fonts.weight.medium};
  margin-bottom: 5px;
`;

export const rowDatePicker = css`
  display: flex;
`;
